var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.85195 1.32336C3.34251 0.935356 -0.206679 2.91336 0.009446 5.1328C0.546446 5.3372 1.01401 5.58704 0.937571 5.84304H15.7081C15.7969 5.086 15.3328 4.5056 15.6468 3.87376C15.7459 3.67424 15.8214 3.44664 15.8738 3.21968V1.99136C15.8662 1.98237 15.8576 1.97476 15.8483 1.96872C12.1806 3.48792 13.9618 3.1668 10.0474 1.96936C9.36813 0.878156 7.11357 0.0879159 6.06263 -0.000244141C5.65907 -0.000244141 4.85201 1.32336 4.85201 1.32336",
    fill: "white",
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.71694 5.19727V5.77839H0.942938C0.951 5.95015 0.729313 6.12639 0.132812 6.29495C0.662438 7.13431 2.22594 7.94111 2.78106 8.03823C2.68169 8.06471 2.57144 8.11183 2.45419 8.17607C4.22925 8.46215 6.32794 8.55895 7.37163 8.58711H10.8151C10.777 8.57615 10.7388 8.56538 10.7006 8.55479C9.93463 8.37015 10.2408 8.50343 9.86831 8.23199C14.7996 6.71239 11.9425 6.93703 15.8455 8.03823C15.9719 7.74767 15.3666 7.03743 15.644 6.13383C15.7494 5.79007 15.7237 5.48399 15.6708 5.19727H9.717H9.71694Z",
    fill: "url(#paint0_linear_1328_2932)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.28794 7.4895V8.07062C5.4635 8.04862 4.03819 8.03638 2.69237 8.0667C1.80337 8.38894 0.232812 10.1064 0.0078125 11.1165V11.5278C0.0148406 11.5493 0.023288 11.5699 0.0330625 11.5895C0.502187 11.7681 0.918312 11.9811 0.96525 12.2029H7.57425V11.6218H15.6777C15.593 11.1408 15.4212 10.7165 15.6452 10.2658C15.8754 9.63118 15.9834 9.19566 15.9983 8.9087V8.78118C15.9337 7.7139 14.1251 9.41294 13.1231 9.42654C11.9881 9.1679 12.2151 8.97454 10.7018 8.55486C9.93581 8.37022 10.242 8.5035 9.8695 8.23206C10.807 7.9431 11.4629 7.71742 11.9376 7.54862V7.4895H6.28794Z",
    fill: "url(#paint1_linear_1328_2932)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.68503 2.90533H5.71028C6.31484 4.27573 5.92966 5.32789 5.60941 6.68245C5.51909 6.95661 5.84497 7.16869 5.93728 6.87621C6.19428 5.61781 6.60134 4.23445 6.11384 2.96989H6.16428C8.49803 2.99285 10.8597 3.53517 12.974 4.84229C13.1145 4.88301 13.5665 5.32789 13.655 4.97149C12.6366 3.42957 8.67353 2.55149 6.99659 2.61445C6.92366 2.63221 6.74909 2.60381 6.54966 2.57573C6.39328 2.55341 6.22128 2.53149 6.07022 2.53149C5.78947 2.53149 5.58216 2.60829 5.68503 2.90533Z",
    fill: "#974DFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.68221 2.90521H5.70746C6.0719 3.78785 6.16546 4.86681 5.80833 5.77841H6.16146C6.34508 4.86257 6.40658 3.88113 6.08583 3.00209C8.44727 3.01113 10.843 3.50601 12.9712 4.87449C13.1112 4.90617 13.59 5.39201 13.6522 5.00361C12.5818 3.43273 8.7184 2.55169 6.99377 2.61433C6.91052 2.63465 6.73752 2.60497 6.54327 2.57497C6.39346 2.55201 6.23077 2.52881 6.08727 2.52881C5.82352 2.52881 5.62315 2.60657 5.68221 2.90521Z",
    fill: "#F1A5FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.77725 3.06666H4.8025C5.29232 3.91986 5.27063 4.9513 4.95388 5.8753C4.84763 6.10002 5.1115 6.32466 5.20607 6.06898C5.38313 5.5909 5.50519 5.05042 5.50876 4.51938C5.51226 3.92178 5.29913 3.30554 5.05476 2.80834C5.02269 2.73442 4.97632 2.7041 4.92863 2.7041C4.80657 2.7041 4.67863 2.90362 4.77725 3.06666Z",
    fill: "#974DFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.3039 5.77851C5.45015 4.99723 5.55865 4.16651 5.22827 3.42179C5.18208 3.29939 5.0459 2.94627 5.05171 2.80843C4.94652 2.55915 4.66658 2.80715 4.77421 3.03435H4.79946C5.24796 3.85411 5.3039 4.87555 4.97608 5.77851H5.30396H5.3039Z",
    fill: "#F1A5FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.77414 3.03435H4.79939C5.24757 3.85403 5.30382 4.87579 4.97595 5.77843H5.30382C5.45007 4.99723 5.55857 4.16651 5.2282 3.42179C5.18201 3.29939 5.04557 2.94619 5.05164 2.80835C5.02039 2.73443 4.97395 2.70435 4.92676 2.70435C4.81457 2.70435 4.69845 2.87459 4.77414 3.03435Z",
    fill: "#F1A5FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.55394 11.6218V12.2029H0.970188C1.0085 12.3846 0.798188 12.5725 0.164062 12.7517C1.38556 14.2709 2.90594 14.7507 4.24969 14.3659C4.45981 15.5781 6.22906 16.2719 7.40263 15.7864C7.41888 15.4764 7.3756 15.166 7.27656 14.8824C8.91669 15.2398 12.9193 13.6288 13.1279 13.4942C13.3168 13.4494 13.8979 13.715 14.4758 13.9811C15.1323 14.2833 15.7845 14.5851 15.8516 14.4305C15.9779 14.1399 15.3726 13.4297 15.6501 12.5257C15.7514 12.1952 15.7315 11.8991 15.6826 11.6218H7.55406H7.55394Z",
    fill: "url(#paint2_linear_1328_2932)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.68503 9.36188H5.71028C6.32066 10.7403 5.91809 11.8057 5.60941 13.1713C5.51909 13.4457 5.84497 13.6575 5.93728 13.3649C6.21322 12.1214 6.59078 10.742 6.11384 9.49068L6.16428 9.45868C8.49722 9.48292 10.8618 9.97524 12.974 11.2988C13.1145 11.3396 13.5665 11.784 13.655 11.428C12.6366 9.88644 8.67353 9.00796 6.99659 9.07132C6.92366 9.08908 6.74941 9.06068 6.55016 9.03252C6.39353 9.01028 6.22128 8.98804 6.07016 8.98804C5.78953 8.98804 5.58216 9.06516 5.68503 9.36188Z",
    fill: "#373FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.68303 9.36188H5.70828C6.06947 10.2351 6.16603 11.3008 5.80916 12.2028H6.16228C6.34716 11.2872 6.40741 10.3055 6.08666 9.42644C8.44559 9.43676 10.8345 9.97812 12.972 11.2988C13.112 11.3396 13.565 11.7844 13.653 11.428C12.6349 9.88644 8.67153 9.00772 6.99459 9.07132C6.92166 9.08908 6.74766 9.06068 6.54816 9.03252C6.39153 9.01028 6.21928 8.98804 6.06816 8.98804C5.78753 8.98804 5.58016 9.06516 5.68303 9.36188Z",
    fill: "#F1A5FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.77543 9.52346H4.80068C5.29049 10.3767 5.2688 11.4082 4.95199 12.3321C4.8458 12.5568 5.10962 12.7815 5.20424 12.5259C5.3813 12.0477 5.50337 11.5076 5.50687 10.9763C5.51674 10.3619 5.27712 9.7601 5.05287 9.2329C4.9283 8.95234 4.60418 9.30138 4.77543 9.52346Z",
    fill: "#373FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.30669 12.2029C5.37175 11.6743 5.52737 11.1375 5.43281 10.5887C5.42019 10.2695 4.79494 8.37594 4.72656 9.49106H4.80225C5.255 10.3107 5.30725 11.3306 4.97881 12.2351L5.30669 12.2029Z",
    fill: "#F1A5FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.72656 9.49075H4.80219C5.25494 10.3107 5.30719 11.3306 4.97875 12.2351L5.30663 12.2028C5.37169 11.6747 5.52731 11.1375 5.43275 10.5887C5.42294 10.3404 5.04356 9.14307 4.84256 9.14307C4.78481 9.14307 4.74194 9.24179 4.72656 9.49075Z",
    fill: "#F1A5FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.73569 3.29272C3.11175 3.29272 3.41669 3.68304 3.41669 4.1644C3.41669 4.64576 3.11169 5.036 2.73569 5.036C2.35962 5.036 2.05469 4.64576 2.05469 4.1644C2.05469 3.68304 2.35969 3.29272 2.73569 3.29272Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.02344 4.09974C2.03731 3.58286 2.37575 3.1783 2.77956 3.19638C3.18331 3.21414 3.49937 3.64774 3.48525 4.1643C3.47187 4.66822 3.14881 5.0679 2.75481 5.06822C2.37981 5.10502 2.05244 4.74566 2.02369 4.26598C2.02344 4.26438 2.02344 4.26278 2.02344 4.26118C2.04232 4.43545 2.1134 4.59348 2.22164 4.70191C2.32988 4.81033 2.46681 4.86065 2.6035 4.84222C2.67968 4.84224 2.75512 4.82306 2.82551 4.78575C2.8959 4.74845 2.95985 4.69376 3.01372 4.62481C3.0676 4.55586 3.11033 4.474 3.13948 4.38391C3.16863 4.29382 3.18363 4.19726 3.18362 4.09974C3.18362 3.68974 2.92381 3.35718 2.6035 3.35718C2.28319 3.35718 2.02344 3.68974 2.02344 4.09974Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.32662 4.09985C2.38012 4.0999 2.43142 4.12712 2.46925 4.17554C2.50708 4.22396 2.52834 4.28962 2.52837 4.35809C2.52836 4.40915 2.51652 4.45905 2.49436 4.50149C2.47219 4.54393 2.44069 4.57701 2.40384 4.59654C2.36699 4.61607 2.32644 4.62117 2.28732 4.61121C2.24821 4.60125 2.21228 4.57666 2.18407 4.54056C2.15587 4.50446 2.13666 4.45847 2.12888 4.4084C2.12109 4.35833 2.12508 4.30643 2.14034 4.25926C2.1556 4.21209 2.18144 4.17177 2.2146 4.14339C2.24775 4.11502 2.28674 4.09987 2.32662 4.09985Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.73569 9.74951C3.11175 9.74951 3.41669 10.1394 3.41669 10.6208C3.41669 11.1022 3.11169 11.4925 2.73569 11.4925C2.35962 11.4925 2.05469 11.1022 2.05469 10.6208C2.05469 10.1394 2.35969 9.74951 2.73569 9.74951Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.02344 10.5242C2.03731 10.0073 2.37575 9.60279 2.77956 9.62095C3.18331 9.63863 3.49937 10.0721 3.48525 10.5887C3.47187 11.093 3.14881 11.4924 2.75481 11.4927C2.37981 11.5295 2.05244 11.1705 2.02369 10.6905C2.02344 10.6889 2.02344 10.6873 2.02344 10.6856C2.02969 10.7743 2.04953 10.8605 2.08183 10.9394C2.11412 11.0182 2.15824 11.0881 2.21167 11.1452C2.26509 11.2022 2.32676 11.2452 2.39317 11.2717C2.45958 11.2982 2.52941 11.3077 2.59869 11.2996C2.6005 11.2993 2.60175 11.299 2.6035 11.299C2.92381 11.2986 3.18338 10.9658 3.18313 10.5558C3.18288 10.1458 2.92281 9.81359 2.60225 9.81391C2.45291 9.81422 2.30941 9.88821 2.2016 10.0205C2.0938 10.1528 2.02998 10.3332 2.02344 10.5242Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.32675 10.5566C2.38027 10.5566 2.43159 10.5839 2.46943 10.6323C2.50727 10.6807 2.52853 10.7464 2.52853 10.8149C2.52853 10.8834 2.50727 10.9491 2.46943 10.9976C2.43159 11.046 2.38027 11.0732 2.32675 11.0732C2.27325 11.0732 2.22196 11.0459 2.18413 10.9975C2.1463 10.9491 2.12503 10.8834 2.125 10.815C2.12497 10.781 2.13016 10.7474 2.14029 10.7161C2.15042 10.6847 2.16527 10.6562 2.18401 10.6322C2.20275 10.6082 2.22501 10.5892 2.2495 10.5762C2.27399 10.5633 2.30024 10.5566 2.32675 10.5566Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1328_2932",
    x1: 371.777,
    y1: 163.316,
    x2: 899.968,
    y2: 438.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF676B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1328_2932",
    x1: 799.533,
    y1: -2.84218,
    x2: 799.533,
    y2: 493.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E3BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3633FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1328_2932",
    x1: 637.32,
    y1: 217.603,
    x2: 792.613,
    y2: 362.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF676B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlitch);
export default __webpack_public_path__ + "static/media/Glitch.0506ef877ec960c8488122fa29e3510a.svg";
export { ForwardRef as ReactComponent };